import React, { useState, useEffect, useContext } from "react";
import { ethers } from "ethers";
import {
  Box,
  Center,
  HStack,
  Text,
  VStack,
  Tooltip,
  Spacer,
} from "@chakra-ui/react";
import { AppContext } from "../../AppContext";
import JakobFactory from "../../contracts/WalletFactoryArbitrum.json";
import BlindfoldWallet from "../../contracts/BlindfoldWalletV2.json";
import CopyToClipboardButton from "../../utils/CopyToClipboardButton";
import { formatAddress } from "../../utils/formatMetamask";
import WalletDetails from "./WalletDetails";

const WalletFactoryInfo = () => {
  const [walletInfo, setWalletInfo] = useState(null);
  const { fastestWebSocket, contractAddress } = useContext(AppContext);
  const provider = new ethers.providers.WebSocketProvider(fastestWebSocket);
  
  const fetchFactoryWalletInfo = async () => {
    try {
      const factoryContract = new ethers.Contract(
        JakobFactory.address,
        JakobFactory.abi,
        provider
      );
      
      const details = await factoryContract.getWalletDetails(contractAddress);
      console.log(details)
      setWalletInfo({
        walletAddress: details[0],
        contractName: details[1],
        category: details[2],
        owner1: details[3],
        owner1Name: details[4],
        owner2: details[5],
        owner2Name: details[6],
        owner3: details[7],
        owner3Name: details[8],
        paymaster: details[9],
      });
    } catch (error) {
      console.error("Error fetching wallet details:", error);
    }
  };

  const fetchOwnersFromWallet = async (contractAddress) => {
    const walletContract = new ethers.Contract(
      contractAddress,
      BlindfoldWallet.abi,
      provider,
    );
    const [owner1, owner2, owner3, paymaster, tradesEnabled, version] = await Promise.all([
      walletContract.owner1(),
      walletContract.owner2(),
      walletContract.owner3(),
      walletContract.paymaster(),
      walletContract.tradesEnabled(),
      walletContract.version(),
    ]);
    return { owner1, owner2, owner3, paymaster, tradesEnabled, version };
  };

  useEffect(() => {
    
      fetchFactoryWalletInfo();
    
  }, [contractAddress]);

  if (!walletInfo) {
    return <Center>Loading wallet details...</Center>;
  }

  return (
    <Box fontFamily="Sentinel-light" maxWidth="330px">
      
      <Box p={1} bg="grey.50" w="100%" shadow='sm' mt={-1} mb={2}>
        <HStack w="100%" alignItems="center" p={1}>
        <Tooltip label={walletInfo.contractName} aria-label="Contract Name">
        <Text as="b" fontSize="sm" isTruncated noOfLines={1}>
          {walletInfo.contractName}
        </Text>
      </Tooltip>
          <HStack gap="2px" justifyContent="flex-end">
            <Text fontSize="sm" isTruncated>
              <a href={`https://arbitrum.blockscout.com/address/${walletInfo.walletAddress}`} target="_blank" rel="noopener noreferrer">
                {formatAddress(walletInfo.walletAddress)}
              </a>
            </Text>
            <CopyToClipboardButton value={walletInfo.walletAddress} />
          </HStack>
        </HStack>
        <VStack bg='white' align="start" spacing={1}  mb={1} fontSize="sm" borderTop='1px solid dodgerblue' borderBottom='1px solid dodgerblue'>
          {["owner1", "owner2", "owner3"].map((ownerKey, index) => (
            <HStack w="100%" key={index}>
              <Text isTruncated>
                <strong>{`Owner${index + 1} (${walletInfo[`${ownerKey}Name`]})`}:</strong>{" "}
                <a href={`https://arbitrum.blockscout.com/address/${walletInfo[ownerKey]}`} target="_blank" rel="noopener noreferrer">
                  {walletInfo[ownerKey]}
                </a>
              </Text>
              <Spacer />
              <CopyToClipboardButton value={walletInfo[ownerKey]} />
            </HStack>
          ))}
          <HStack w="100%">
            <Text isTruncated>
              <strong>Paymaster:</strong>{" "}
              <a href={`https://arbitrum.blockscout.com/address/${walletInfo.paymaster}`} target="_blank" rel="noopener noreferrer">
                {walletInfo.paymaster}
              </a>
            </Text>
            <Spacer />
            <CopyToClipboardButton value={walletInfo.paymaster} />
          </HStack>
          <HStack w="100%" >
            <Text>
              <strong>Type:</strong>{" "}
            </Text>
            <Text>{walletInfo.category}</Text>
          </HStack>

          <WalletDetails paymasterAddress={walletInfo.paymaster}/> 
        </VStack>
      </Box>
    </Box>
  );
};

export default WalletFactoryInfo;
